import { useTranslation } from 'react-i18next';

export default function LendingAboutSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-900" id="learn-more">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.about.title')}
          </h2>
        </div>

        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              {t('lending.about.desc1')}
            </p>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              {t('lending.about.desc2')}
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              {t('lending.about.desc3')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
